/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sub_Group_ByInputs */

const en_disp_sub_group_by = /** @type {(inputs: Disp_Sub_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-group by`)
};

const de_disp_sub_group_by = /** @type {(inputs: Disp_Sub_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untergruppen nach`)
};

/**
* | output |
* | --- |
* | "Sub-group by" |
*
* @param {Disp_Sub_Group_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sub_group_by = /** @type {((inputs?: Disp_Sub_Group_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sub_Group_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sub_group_by(inputs)
	return en_disp_sub_group_by(inputs)
});